import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Styles from "./ActiveConnections.module.css";

import { ReactComponent as ExpandMoreIcon } from "../../../../assets/images/expandMoreIcon.svg";

import TermsConditionModal from "../../../Modals/Banking/TermsConditionModal/TermsConditionModal";
import UploadDocModal from "../../../Modals/Banking/UploadDocModal/UploadDocModal";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../../commons/Accordion";
import { ReactComponent as SquareIcon } from "../../../../assets/images/squareIcon.svg";
import {
  fetchLedgerBanking,
  fetchMatchmakingResults,
  setActiveListingId,
} from "../../../../Redux/Slices/bankingSlice";
import { useDispatch, useSelector } from "react-redux";
import ViewInjectionModal from "../../../Modals/Banking/ViewInjectionModal/ViewInjectionModal";
import ViewDrawalModal from "../../../Modals/Banking/ViewDrawalModal/ViewDrawalModal";
import { ReactComponent as HistoryIcon } from "../../../../assets/images/history.svg";
import { ReactComponent as VectorIcon } from "../../../../assets/images/VectorIcon.svg";
import ConnectionHistory from "../../../Modals/Banking/ConnectionHistory/ConnectionHistory";
import ViewDoc from "../../../Modals/Banking/ViewDoc/ViewDoc";
import ChatApplication from "../../../ChatApplication/ChatApplication";
import { Skeleton, Tooltip } from "@mui/material";
import { ReactComponent as InfoOutlinedIcon } from "../../../../assets/images/info.svg";

const ActiveConnections = ({
  data = [],
  activeListingId = [],
  onAgreementAccepted,
  onAllDocsUploaded,
  currentPage = 0,
  itemsPerPage = 10,
  totalCount = 0,
  onPageChange,
  isLoading = false,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedConnection, setSelectedConnection] = useState(null);
  const [finalModal, setFinalModal] = useState(false);
  const [acceptedConnections, setAcceptedConnections] = useState([]);
  const [uploadModal, setUploadModal] = useState(false);
  const [viewInjectionModalOpen, setViewInjectionModalOpen] = useState(false);
  const [selectedInjectionData, setSelectedInjectionData] = useState([]);
  const [viewDrawalModalOpen, setViewDrawalModalOpen] = useState(false);
  const [selectedDrawalData, setSelectedDrawalData] = useState([]);
  const userData = useSelector((state) => state.persistedReducer);
  const [selectedCounterparty, setSelectedCounterparty] = useState(null);
  const [modalViewOnly, setModalViewOnly] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [chatConnectionId, setChatConnectionId] = useState(null);
  const [chatName, setChatName] = useState("");
  const [connectionHistoryOpen, setConnectionHistoryOpen] = useState(false);
  const [historyConnectionId, setHistoryConnectionId] = useState(null);
  const [viewDocModalOpen, setViewDocModalOpen] = useState(false);
  const [viewDocConnectionId, setViewDocConnectionId] = useState(null);
  const [activeViewCounterparty, setActiveViewCounterparty] = useState(null);
  const [modalApprovalMode, setModalApprovalMode] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  const userId = userData?.user?.user?.userId;

  const handleOpenModal = (
    connection,
    counterparty,
    { viewOnly = false, isApprovalMode = false } = {},
  ) => {
    setSelectedConnection(connection);
    setSelectedCounterparty(counterparty);
    setModalViewOnly(viewOnly);
    setModalApprovalMode(isApprovalMode);
    setFinalModal(true);
  };

  const handleCloseModal = () => setFinalModal(false);

  const handleAccepted = (id) => {
    setAcceptedConnections((prev) => [...prev, id]);
    handleCloseModal();
  };

  const handleDeclined = (id) => {
    setAcceptedConnections((prev) => [...prev, id]);
    handleCloseModal();
  };

  const handleUploadModalOpen = (item, counterparty) => {
    setSelectedConnection(item);
    setSelectedCounterparty(counterparty);
    setUploadModal(true);
  };

  const handleUploadClose = () => setUploadModal(false);

  const handleAllDocsUploaded = () => {
    handleCloseModal();
    dispatch(fetchLedgerBanking({ currentPage, size: itemsPerPage }));

    if (typeof onAgreementAccepted === "function") {
      onAgreementAccepted();
    }
  };

  const handleNavigateToListing = (selfListing) => {
    if (selfListing?.id) {
      // Set the active listing ID first
      dispatch(setActiveListingId(selfListing.id));

      dispatch(
        fetchMatchmakingResults({
          id: selfListing.id,
          statusFilter: null,
        }),
      );
      navigate(`/banking_active?id=${selfListing.id}`, {
        state: {
          fromBankingLedger: true,
          activeTab: "Active Connections",
          listingId: selfListing.id,
          listingName: selfListing.name,
        },
      });
    }
  };

  const agreementStatus = selectedCounterparty?.agreementStatus || "";

  const finalAgreementFile = {
    name: selectedConnection?.agreementDocumentName || "",
    url: selectedConnection?.agreementDocumentUrl || "",
  };

  const totalPages = Math.ceil(totalCount / itemsPerPage) || 1;

  const handlePrevClick = () => {
    onPageChange(currentPage - 1);
  };

  const handleNextClick = () => {
    onPageChange(currentPage + 1);
  };

  const handleViewInjection = (slotData) => {
    if (!slotData || slotData.length === 0) return;
    setSelectedInjectionData(slotData);
    setViewInjectionModalOpen(true);
  };

  const handleViewDrawal = (slotData) => {
    if (!slotData || slotData.length === 0) return;
    setSelectedDrawalData(slotData);
    setViewDrawalModalOpen(true);
  };
  const handleOpenConnectionHistory = (selfListingId) => {
    setHistoryConnectionId(selfListingId);
    setConnectionHistoryOpen(true);
  };

  const handleCloseConnectionHistory = () => {
    setHistoryConnectionId(null);
    setConnectionHistoryOpen(false);
  };

  const handleChatOpen = (chatConnectionId, name) => {
    setChatConnectionId(chatConnectionId);
    setChatName(name);
    setChatOpen(true);
  };

  const handleOpenViewDoc = (connectionId, counterparty) => {
    setViewDocConnectionId(connectionId);
    setActiveViewCounterparty(counterparty);
    setViewDocModalOpen(true);
  };

  const handleCloseViewDoc = () => {
    setViewDocModalOpen(false);
    setViewDocConnectionId(null);
  };

  const shouldShowAlreadyAcceptedMessage = (
    selectedConnection,
    selectedCounterparty,
  ) => {
    if (
      !selectedConnection?.counterPartyListings ||
      !Array.isArray(selectedConnection.counterPartyListings)
    ) {
      return false;
    }
    return (
      selectedConnection.counterPartyListings.some(
        (cp) => cp.status === "TERMS_ACCEPTED" || cp.status === "COMPLETED",
      ) && selectedCounterparty?.status !== "ACTIVE"
    );
  };

  const skeletonRowCount = 8;
  const formattedStatus = (status) => {
    if (!status) return "—";
    if (status === "COMPLETED") return "Ongoing";
    return status
      .toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const handleScrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {finalModal && (
        <TermsConditionModal
          activeData={selectedConnection}
          activeCounterparty={selectedCounterparty}
          open={finalModal}
          activeListingId={activeListingId}
          handleClose={handleCloseModal}
          connectionId={selectedConnection?.id}
          counterpartyId={selectedCounterparty?.id}
          onAccept={() => handleAccepted(selectedCounterparty?.id)}
          onDecline={() => handleDeclined(selectedCounterparty?.id)}
          currentUserListingIds={activeListingId}
          termsData={data}
          viewOnly={modalViewOnly}
          isApprovalMode={modalApprovalMode}
        />
      )}

      {uploadModal && (
        <UploadDocModal
          open={uploadModal}
          handleClose={handleUploadClose}
          connectionId={
            selectedCounterparty?.connectionId || selectedConnection?.id
          }
          activeListingId={activeListingId}
          activeCounterparty={selectedCounterparty}
          onAllDocsUploaded={handleAllDocsUploaded}
          upData={data}
          agreementStatus={agreementStatus}
          finalAgreementFile={finalAgreementFile}
          isCounterparty={
            !!selectedCounterparty?.agreementInitiatorId &&
            selectedCounterparty?.agreementInitiatorId !== userId
          }
        />
      )}

      {viewInjectionModalOpen && (
        <ViewInjectionModal
          open={viewInjectionModalOpen}
          handleClose={() => setViewInjectionModalOpen(false)}
          data={selectedInjectionData}
        />
      )}

      {viewDrawalModalOpen && (
        <ViewDrawalModal
          open={viewDrawalModalOpen}
          handleClose={() => setViewDrawalModalOpen(false)}
          data={selectedDrawalData}
        />
      )}

      {connectionHistoryOpen && (
        <ConnectionHistory
          connectionId={historyConnectionId}
          // listingId={selfListingId}
          open={connectionHistoryOpen}
          handleClose={handleCloseConnectionHistory}
        />
      )}

      {viewDocModalOpen && (
        <ViewDoc
          open={viewDocModalOpen}
          handleClose={handleCloseViewDoc}
          connectionId={viewDocConnectionId}
          viewDocData={data}
          activeCounterparty={activeViewCounterparty}
        />
      )}

      {chatOpen && (
        <ChatApplication
          open={chatOpen}
          handleClose={() => setChatOpen(false)}
          chatId={chatConnectionId}
          userName={chatName}
        />
      )}

      <div className={Styles.tableAreaMain}>
        <div className={`display_flex_row ${Styles.tableActiveCont}`}>
          <div className={`${Styles.tableHeaderActive} display_flex_row`}>
            <div style={{ width: "2px" }}></div>
            <div style={{ width: "18%" }}>Listing ID</div>
            <div style={{ width: "20%" }}>Injection Range</div>
            <div style={{ width: "17%" }}>Drawal Range</div>
            <div style={{ width: "10%" }}>BF(%)</div>
            <div style={{ width: "10%", paddingRight: "1.5%" }}>SR(₹/kWh)</div>
            <div style={{ width: "10%" }}>Status</div>
          </div>
          <div className={`${Styles.tableContent} `}>
            <div className={`scroll_bar_y ${Styles.tableContentActive}`}>
              {isLoading
                ? Array.from({ length: skeletonRowCount }).map((_, index) => (
                    <div
                      className={` ${Styles.tableHeaderInnerActive} 
                                  display_flex_row `}
                      key={index}
                    >
                      {/* Match width% with your headers */}
                      <div style={{ width: "5px" }}></div>
                      <div style={{ width: "19%" }}>
                        <Skeleton width={120} />
                      </div>
                      <div style={{ width: "19%" }}>
                        <Skeleton width={150} />
                      </div>
                      <div style={{ width: "18%" }}>
                        <Skeleton width={150} />
                      </div>
                      <div style={{ width: "12%" }}>
                        <Skeleton width={40} />
                      </div>
                      <div style={{ width: "10.5%", paddingRight: "1.5%" }}>
                        <Skeleton width={70} />
                      </div>
                      <div style={{ width: "10%" }}>
                        <Skeleton width={30} />
                      </div>
                    </div>
                  ))
                : data
                    .filter(
                      (item) =>
                        activeListingId.includes(item?.selfListing?.id) ||
                        acceptedConnections.includes(item?.selfListing?.id),
                    )
                    .map((item, index) => {
                      const inject = item?.selfListing?.bankingSlotInjects?.[0];
                      const drawal = item?.selfListing?.bankingSlotDrawls?.[0];

                      return (
                        <Accordion
                          key={index}
                          expanded={false}
                          onChange={() =>
                            handleNavigateToListing(item?.selfListing)
                          }
                          className={`${Styles.activeAccordion}`}
                        >
                          <AccordionSummary>
                            <div
                              className={`display_flex_row ${Styles.tableActiveCont}`}
                            >
                              <div
                                className={`
                                  ${Styles.tableHeaderInnerActive} 
                                  display_flex_row 
                                  ${
                                    index % 2 === 0
                                      ? Styles.evenRow
                                      : Styles.oddRow
                                  }
                                `}
                              >
                                <div style={{ width: "5px" }}>
                                  <ExpandMoreIcon
                                    className={`${Styles.expandIconLeft}`}
                                  />
                                </div>
                                <div
                                  style={{ width: "15%" }}
                                  // className="table_text_align_left"
                                  className={Styles.companyLeft}
                                >
                                  <>
                                    <div
                                      style={{
                                        fontSize: "10px",
                                        color: "#8C8A96",
                                      }}
                                    >
                                      {item?.selfListing?.name || "—"}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: "12px",
                                      }}
                                    >
                                      <div
                                        title={
                                          item.counterPartyListings[0]
                                            .companyName
                                        }
                                      >
                                        {item?.counterPartyListings &&
                                        item.counterPartyListings.length > 0 ? (
                                          <div
                                            style={{
                                              maxWidth: "150px",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "nowrap",
                                              color: "#525062",
                                              fontWeight: "500",
                                            }}
                                          >
                                            {item.counterPartyListings[0]
                                              .companyName || "—"}
                                            {/* {item.counterPartyListings.length >
                                              1 &&
                                              ` +${
                                                item.counterPartyListings
                                                  .length - 1
                                              } more`} */}
                                          </div>
                                        ) : (
                                          "—"
                                        )}
                                      </div>
                                    </div>
                                  </>
                                </div>
                                <div
                                  className="display_flex_row_gap_4_only"
                                  style={{
                                    width: "19%",
                                    textAlign: "left",
                                  }}
                                >
                                  {inject?.dateStartAt || "—"} to{" "}
                                  {inject?.dateEndAt || "—"}{" "}
                                  <span
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedInjectionData(
                                        item?.selfListing?.bankingSlotInjects ||
                                          [],
                                      );
                                      setViewInjectionModalOpen(true);
                                    }}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <SquareIcon />
                                  </span>
                                </div>
                                <div
                                  className={`display_flex_row_gap_4_only `}
                                  style={{
                                    width: "22%",
                                  }}
                                >
                                  {drawal?.dateStartAt || "—"} to{" "}
                                  {drawal?.dateEndAt || "—"}
                                  <span
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedDrawalData(
                                        item?.selfListing?.bankingSlotDrawls ||
                                          [],
                                      );
                                      setViewDrawalModalOpen(true);
                                    }}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <SquareIcon />
                                  </span>
                                </div>
                                <div style={{ width: "10%" }}>
                                  {item?.selfListing?.bankingFactor
                                    ? `${item?.selfListing.bankingFactor}`
                                    : "—"}
                                </div>
                                <div
                                  style={{
                                    width: "10%",
                                    // paddingRight: "1.5%",
                                  }}
                                >
                                  {item?.selfListing?.settlementRate || "—"}
                                </div>
                                <div style={{ width: "12%" }}>
                                  <span className={Styles.selfStatus}>
                                    {" "}
                                    {formattedStatus(
                                      item?.selfListing?.status,
                                    ) || "—"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <div className={Styles.accDetails_bank}>
                              <div
                                className={`display_flex_row_center ${Styles.counterListings}`}
                              >
                                Counterparty Listings
                              </div>
                              <div className={Styles.counterTableHeader}>
                                <div
                                  className={`display_flex_row ${Styles.detailDetailsHeader}`}
                                >
                                  <div
                                    style={{
                                      width: "12%",
                                      paddingLeft: "10px",
                                    }}
                                    className="table_text_align_left"
                                  >
                                    Name
                                  </div>
                                  <div style={{ width: "20%" }}>
                                    Injection Range
                                  </div>
                                  <div style={{ width: "21%" }}>
                                    Drawal Range
                                  </div>
                                  <div style={{ width: "12%" }}>BF</div>
                                  <div style={{ width: "9%" }}>SR</div>
                                  <div style={{ width: "14%" }}>Operations</div>
                                </div>
                              </div>
                              <div
                                className={`scroll_bar_y ${Styles.counterListingDetails}`}
                              >
                                {item?.counterPartyListings &&
                                item.counterPartyListings.length > 0 ? (
                                  item.counterPartyListings.map(
                                    (counterparty, idx) => {
                                      const inject =
                                        counterparty?.bankingSlotInjects?.[0];
                                      const drawal =
                                        counterparty?.bankingSlotDrawls?.[0];
                                      const counterpartyUserId =
                                        counterparty.userId;

                                      const termsInitiatorId =
                                        counterparty?.termsInitiatorId;
                                      const connectionIsTermsInitiated =
                                        counterparty?.connectionStatus ===
                                        "TERMS_INITIATED";
                                      const loggedInUserId = userId;

                                      const showApproveButton =
                                        connectionIsTermsInitiated &&
                                        termsInitiatorId &&
                                        loggedInUserId !== termsInitiatorId &&
                                        loggedInUserId !== counterpartyUserId;

                                      const isTermsAccepted =
                                        counterparty.connectionStatus ===
                                        "TERMS_ACCEPTED";
                                      const isFinalizedEmpty =
                                        !counterparty.finalizedConnectionValues ||
                                        (!counterparty.finalizedConnectionValues
                                          .bankingFactor &&
                                          !counterparty
                                            .finalizedConnectionValues
                                            .settlementRate &&
                                          (!counterparty
                                            .finalizedConnectionValues
                                            .slotDrawls ||
                                            counterparty
                                              .finalizedConnectionValues
                                              .slotDrawls.length === 0) &&
                                          (!counterparty
                                            .finalizedConnectionValues
                                            .slotInjects ||
                                            counterparty
                                              .finalizedConnectionValues
                                              .slotInjects.length === 0));

                                      const agreementInit =
                                        counterparty?.agreementInitiatorId ===
                                        loggedInUserId;
                                      const viewDocs =
                                        agreementInit &&
                                        counterparty?.agreementStatus ===
                                          "UPLOADED";

                                      const approveDocs =
                                        !agreementInit &&
                                        counterparty?.agreementStatus ===
                                          "UPLOADED";

                                      return (
                                        <div className={Styles.detailMainElem}>
                                          <div
                                            className={`display_flex_row ${Styles.detailDetailsElement}`}
                                          >
                                            <div
                                              style={{ width: "21%" }}
                                              className={`display_flex_column_gap_4 ${Styles.listingCont_Name}`}
                                            >
                                              <div>
                                                {" "}
                                                {counterparty?.companyName ||
                                                  "—"}
                                              </div>
                                              <div>
                                                {counterparty?.name || "—"}
                                              </div>
                                            </div>
                                            <div
                                              className="display_flex_row_gap_8_only"
                                              style={{ width: "25.5%" }}
                                            >
                                              {inject?.dateStartAt || "—"} to{" "}
                                              {inject?.dateEndAt || "—"}
                                              <span
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setSelectedInjectionData(
                                                    counterparty?.bankingSlotInjects ||
                                                      [],
                                                  );
                                                  setViewInjectionModalOpen(
                                                    true,
                                                  );
                                                }}
                                                style={{ cursor: "pointer" }}
                                              >
                                                <SquareIcon />
                                              </span>
                                            </div>
                                            <div
                                              className="display_flex_row_gap_8_only"
                                              style={{
                                                width: "23%",
                                              }}
                                            >
                                              {drawal?.dateStartAt || "—"} to{" "}
                                              {drawal?.dateEndAt || "—"}
                                              <span
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setSelectedDrawalData(
                                                    counterparty?.bankingSlotDrawls ||
                                                      [],
                                                  );
                                                  setViewDrawalModalOpen(true);
                                                }}
                                                style={{ cursor: "pointer" }}
                                              >
                                                <SquareIcon />
                                              </span>
                                            </div>
                                            <div style={{ width: "15%" }}>
                                              {counterparty?.bankingFactor ||
                                                "—"}
                                            </div>
                                            <div style={{ width: "14%" }}>
                                              {counterparty?.settlementRate ||
                                                "—"}
                                            </div>
                                            <div
                                              style={{ width: "17%" }}
                                              className={`display_flex_row_gap_8 ${Styles.elementButtons}`}
                                            >
                                              {counterparty.connectionStatus ===
                                                "LEDGER" && isFinalizedEmpty ? (
                                                <>
                                                  {!(
                                                    shouldShowAlreadyAcceptedMessage(
                                                      item,
                                                      counterparty,
                                                    ) ||
                                                    item?.selfListing
                                                      ?.status ===
                                                      "TERMS_ACCEPTED" ||
                                                    item?.selfListing
                                                      ?.status === "COMPLETED"
                                                  ) ? (
                                                    <>
                                                      <div
                                                        className={
                                                          Styles.chatBtn
                                                        }
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          handleChatOpen(
                                                            counterparty?.connectionId,
                                                            counterparty?.name,
                                                          )
                                                        }
                                                      >
                                                        Chat
                                                      </div>
                                                      <div
                                                        className={`activeButton_type_2`}
                                                        onClick={() => {
                                                          handleOpenModal(
                                                            item,
                                                            counterparty,
                                                            {
                                                              viewOnly: false,
                                                              isApprovalMode: false,
                                                            },
                                                          );
                                                        }}
                                                      >
                                                        Finalize T&C
                                                      </div>
                                                    </>
                                                  ) : (
                                                    <span
                                                      className={
                                                        counterparty?.status ===
                                                        "COMPLETED"
                                                          ? `${Styles.statusText} `
                                                          : Styles.statusText
                                                      }
                                                    >
                                                      {" "}
                                                      {/* {counterparty?.status ===
                                                      "COMPLETED"
                                                        ? "ONGOING"
                                                        : counterparty?.status} */}
                                                      {
                                                        counterparty?.connectionStatus
                                                      }
                                                    </span>
                                                  )}
                                                </>
                                              ) : (
                                                <>
                                                  {counterparty?.connectionStatus ===
                                                    "AUTO_WITHDRAW" && (
                                                    <span
                                                      className={
                                                        Styles.withdrawBtn
                                                      }
                                                    >
                                                      Chats
                                                    </span>
                                                  )}
                                                  <span
                                                    // className={
                                                    //   Styles.withdrawText
                                                    // }
                                                    className={
                                                      counterparty?.connectionStatus ===
                                                      "AUTO_WITHDRAW"
                                                        ? `${Styles.statusText} ${Styles.withdrawText} `
                                                        : Styles.statusText
                                                    }
                                                  >
                                                    {counterparty?.connectionStatus ===
                                                    "AUTO_WITHDRAW" ? (
                                                      <>
                                                        <Tooltip
                                                          title="Terms and conditions have already been accepted by another
                                                                 counterparty."
                                                        >
                                                          <span
                                                            className={
                                                              Styles.infoIcon
                                                            }
                                                          >
                                                            <InfoOutlinedIcon
                                                              // fontSize="small"
                                                              width={12}
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                            />{" "}
                                                          </span>
                                                          <span
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                          >
                                                            Withdrawan
                                                          </span>
                                                        </Tooltip>
                                                      </>
                                                    ) : counterparty?.connectionStatus ===
                                                        "TERMS_ACCEPTED" ||
                                                      counterparty?.connectionStatus ===
                                                        "ONGOING" ? (
                                                      formattedStatus(
                                                        counterparty?.connectionStatus,
                                                      )
                                                    ) : (
                                                      <div
                                                        className={`display_flex_row_gap_4 ${Styles.button_mainContainer}`}
                                                      >
                                                        <div
                                                          className={
                                                            Styles.chatBtn
                                                          }
                                                          style={
                                                            true
                                                              ? {
                                                                  cursor:
                                                                    "pointer",
                                                                }
                                                              : {}
                                                          }
                                                          onClick={
                                                            true
                                                              ? () =>
                                                                  handleChatOpen(
                                                                    counterparty?.connectionId,
                                                                    counterparty?.name,
                                                                  )
                                                              : undefined
                                                          }
                                                        >
                                                          Chat
                                                        </div>
                                                        {showApproveButton ? (
                                                          <div
                                                            className="activeButton"
                                                            onClick={() =>
                                                              handleOpenModal(
                                                                item?.selfListing,
                                                                counterparty,
                                                                {
                                                                  viewOnly: true,
                                                                  isApprovalMode: true,
                                                                },
                                                              )
                                                            }
                                                          >
                                                            Approve T&C
                                                          </div>
                                                        ) : (
                                                          <div
                                                            className="activeButton_type_2"
                                                            onClick={() =>
                                                              handleOpenModal(
                                                                item?.selfListing,
                                                                counterparty,
                                                                {
                                                                  viewOnly: true,
                                                                  isApprovalMode: false,
                                                                },
                                                              )
                                                            }
                                                          >
                                                            View T&C
                                                          </div>
                                                        )}
                                                      </div>
                                                    )}
                                                  </span>
                                                </>
                                              )}
                                            </div>
                                          </div>
                                          {counterparty?.connectionStatus !==
                                            "AUTO_WITHDRAW" &&
                                            counterparty?.connectionStatus !==
                                              "TERMS_INITIATED" &&
                                            Object.keys(
                                              counterparty?.finalizedConnectionValues ||
                                                {},
                                            ).length > 0 &&
                                            counterparty.connectionStatus !==
                                              "LEDGER" && (
                                              <div
                                                className={`${Styles.finalMainContainer}`}
                                              >
                                                <div
                                                  className={`display_flex_row ${Styles.detailFinalElement}`}
                                                >
                                                  <div
                                                    style={{ width: "16%" }}
                                                    className={`display_flex_column_gap_4 ${Styles.finalT_CText}`}
                                                  >
                                                    Final Terms and Conditions
                                                  </div>
                                                  <div
                                                    className="display_flex_row_gap_8_only"
                                                    style={{
                                                      width: "20%",
                                                    }}
                                                  >
                                                    {counterparty
                                                      ?.finalizedConnectionValues
                                                      ?.slotInjects?.[0]
                                                      ?.dateStartAt +
                                                      " to " +
                                                      counterparty
                                                        ?.finalizedConnectionValues
                                                        ?.slotInjects?.[0]
                                                        ?.dateEndAt}

                                                    <span
                                                      onClick={() =>
                                                        handleViewInjection(
                                                          counterparty
                                                            ?.finalizedConnectionValues
                                                            ?.slotInjects,
                                                        )
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      <SquareIcon />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className="display_flex_row_gap_8_only"
                                                    style={{
                                                      width: "20%",
                                                    }}
                                                  >
                                                    {counterparty
                                                      ?.finalizedConnectionValues
                                                      ?.slotDrawls?.[0]
                                                      ?.dateStartAt +
                                                      " to " +
                                                      counterparty
                                                        ?.finalizedConnectionValues
                                                        ?.slotDrawls?.[0]
                                                        ?.dateEndAt}

                                                    <span
                                                      onClick={() =>
                                                        handleViewDrawal(
                                                          counterparty
                                                            ?.finalizedConnectionValues
                                                            ?.slotDrawals,
                                                        )
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      <SquareIcon />
                                                    </span>
                                                  </div>
                                                  <div
                                                    style={{
                                                      width: "8%",
                                                    }}
                                                  >
                                                    {
                                                      counterparty
                                                        ?.finalizedConnectionValues
                                                        ?.bankingFactor
                                                    }
                                                  </div>
                                                  <div
                                                    style={{
                                                      width: "12%",
                                                    }}
                                                  >
                                                    {
                                                      counterparty
                                                        ?.finalizedConnectionValues
                                                        ?.settlementRate
                                                    }
                                                  </div>
                                                  <div
                                                    style={{
                                                      width: "12%",
                                                    }}
                                                  >
                                                    -
                                                  </div>
                                                </div>
                                                <div className="display_flex_row">
                                                  <div
                                                    className={Styles.connHead}
                                                    onClick={() =>
                                                      handleOpenConnectionHistory(
                                                        item?.selfListing?.id,
                                                      )
                                                    }
                                                  >
                                                    <span>
                                                      <HistoryIcon
                                                        style={{
                                                          width: 14,
                                                          height: 14,
                                                        }}
                                                      />
                                                    </span>
                                                    Connection History
                                                    <span
                                                      onClick={() =>
                                                        handleOpenConnectionHistory(
                                                          item?.selfListing?.id,
                                                        )
                                                      }
                                                    >
                                                      <VectorIcon
                                                        style={{
                                                          width: 8,
                                                          height: 8,
                                                          cursor: "pointer",
                                                        }}
                                                      />
                                                    </span>
                                                  </div>
                                                  <div
                                                    className={`display_flex_row_gap_8 ${Styles.button_mainContainer}`}
                                                  >
                                                    <div
                                                      className={`display_flex_row_gap_8 ${Styles.button_mainContainer}`}
                                                    >
                                                      <div
                                                        className={
                                                          Styles.chatBtn
                                                        }
                                                        style={
                                                          true
                                                            ? {
                                                                cursor:
                                                                  "pointer",
                                                              }
                                                            : {}
                                                        }
                                                        onClick={
                                                          true
                                                            ? () =>
                                                                handleChatOpen(
                                                                  counterparty?.connectionId,
                                                                  counterparty?.name,
                                                                )
                                                            : undefined
                                                        }
                                                      >
                                                        Chat
                                                      </div>
                                                      <div
                                                        className="activeButton_type_2"
                                                        onClick={() => {
                                                          handleOpenModal(
                                                            item?.selfListing,
                                                            counterparty,
                                                            {
                                                              viewOnly: true,
                                                              isApprovalMode: false,
                                                            },
                                                          );
                                                        }}
                                                      >
                                                        View T&C
                                                      </div>
                                                      <div
                                                        className="activeButton_type_2"
                                                        onClick={() => {
                                                          handleOpenViewDoc(
                                                            counterparty?.connectionId,
                                                            counterparty,
                                                          );
                                                        }}
                                                      >
                                                        View Docs
                                                      </div>
                                                      {isTermsAccepted &&
                                                        counterparty?.agreementStatus ===
                                                          "NOT_UPLOADED" && (
                                                          <div
                                                            className="activeButton"
                                                            onClick={() =>
                                                              handleUploadModalOpen(
                                                                item,
                                                                counterparty,
                                                              )
                                                            }
                                                          >
                                                            Documentation
                                                          </div>
                                                        )}
                                                      {isTermsAccepted &&
                                                        viewDocs && (
                                                          // <div
                                                          //   className="activeButton_type_2"
                                                          //   onClick={() =>
                                                          //     handleOpenViewDoc(
                                                          //       ele?.connectionId,
                                                          //       ele
                                                          //     )
                                                          //   }
                                                          // >
                                                          //   View Docs
                                                          // </div>
                                                          <div
                                                            className="activeButton"
                                                            onClick={() =>
                                                              handleUploadModalOpen(
                                                                item,
                                                                counterparty,
                                                              )
                                                            }
                                                          >
                                                            Edit Documents
                                                          </div>
                                                        )}
                                                      {isTermsAccepted &&
                                                        approveDocs && (
                                                          <div
                                                            className="activeButton"
                                                            onClick={() =>
                                                              handleUploadModalOpen(
                                                                item,
                                                                counterparty,
                                                              )
                                                            }
                                                          >
                                                            Accept Agreement
                                                          </div>
                                                        )}
                                                      {showApproveButton && (
                                                        <div
                                                          className="activeButton"
                                                          onClick={() =>
                                                            handleOpenModal(
                                                              item,
                                                              counterparty,
                                                              {
                                                                viewOnly: true,
                                                                isApprovalMode: true,
                                                              },
                                                            )
                                                          }
                                                        >
                                                          Approve T&C
                                                        </div>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                        </div>
                                      );
                                    },
                                  )
                                ) : (
                                  <div className={Styles.noCounterparty}>
                                    No Counterparty Listings
                                  </div>
                                )}
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      );
                    })}
            </div>
          </div>
        </div>
        {/* <div className={Styles.paginationWrapper}>
          <button
            disabled={currentPage <= 0 || isLoading}
            onClick={handlePrevClick}
          >
            Prev
          </button>
          <span>
            Page {currentPage + 1} of {totalPages}
          </span>
          <button
            disabled={currentPage + 1 >= totalPages || isLoading}
            onClick={handleNextClick}
          >
            Next
          </button>
        </div> */}
        {showScrollTop && (
          <div className={Styles.scrollTopBtn} onClick={handleScrollTop}>
            ↑
          </div>
        )}
      </div>
    </>
  );
};

export default ActiveConnections;
